import { Link, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import { blogSpanComponent } from "../utils/blogColors";
import { useFetch } from "../hooks/useFetch";
import { getBlogPost } from "../services/firestore";
import { LoadingTerminal } from "../components/ui/LoadingState";
import SEO from "../components/ui/SEO";
import "./Blog.css";

export default function BlogPostPage() {
  const { slug } = useParams();
  const { data: post, loading, error } = useFetch(() => getBlogPost(slug), [slug]);

  return (
    <main className="blog-post" aria-label="Main content">
      {post && (
        <SEO
          title={post.title}
          description={post.excerpt || post.title}
          url={`/blog/${post.slug}`}
          image={post.cover_image_url}
          type="article"
        />
      )}

      <div className="container">
        {loading && (
          <LoadingTerminal
            title="blog.post"
            lines={["content.render", "meta.display"]}
            meta="loading post"
          />
        )}

        {error && (
          <div className="blog-error">
            <p className="blog-error__text">Failed to load blog post.</p>
          </div>
        )}

        {!loading && !error && !post && (
          <div className="blog-empty">
            <div className="blog-empty__icon">&#128269;</div>
            <p className="blog-empty__text">Blog post not found.</p>
            <Link to="/blog" className="btn btn-outline" style={{ marginTop: "1rem" }}>
              &larr; Back to blog
            </Link>
          </div>
        )}

        {!loading && !error && post && (
          <>
            <Link to="/blog" className="blog-post__back">
              &larr; all posts
            </Link>

            {post.cover_image_url && (
              <img
                className="blog-post__cover"
                src={post.cover_image_url}
                alt={post.title}
              />
            )}

            <div className="blog-post__header">
              <h1 className="blog-post__title">{post.title}</h1>
              <div className="blog-post__meta">
                {post.date && <span className="blog-post__date">{post.date}</span>}
                {post.date && post.tags && post.tags.length > 0 && (
                  <span className="blog-post__dot" />
                )}
                {post.tags && post.tags.length > 0 && (
                  <div className="blog-post__tags">
                    {post.tags.map((tag) => (
                      <span key={tag} className="blog-post__tag">{tag}</span>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <article className="blog-prose">
              <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]} components={{ span: blogSpanComponent }}>{post.content}</ReactMarkdown>
            </article>
          </>
        )}
      </div>
    </main>
  );
}
